(function () {
  const sections = document.querySelectorAll('[data-holy-summer]');
  if (!sections.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const mosaic = section.querySelector('[data-holy-summer-mosaic]');
    const tiles = [...section.querySelectorAll('[data-holy-summer-tile]')];
    if (!mosaic || !tiles.length) return;

    if (!reduced) {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );

      tiles.forEach((tile) => revealObserver.observe(tile));

      let scrollRaf = null;
      const updateScrollParallax = () => {
        scrollRaf = null;
        const rect = mosaic.getBoundingClientRect();
        const viewHeight = window.innerHeight || 1;
        const progress = (viewHeight - rect.top) / (viewHeight + rect.height);
        const clamped = Math.min(1, Math.max(0, progress));

        tiles.forEach((tile) => {
          const speed = Number(tile.dataset.parallax || 0.04);
          const offset = (clamped - 0.5) * speed * 220;
          const inner = tile.querySelector('.holy-summer__tile-inner');
          if (inner) {
            inner.style.setProperty('--holy-parallax-y', `${offset}px`);
          }
        });
      };

      const onScroll = () => {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(updateScrollParallax);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      updateScrollParallax();

      mosaic.addEventListener('mousemove', (event) => {
        const bounds = mosaic.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;

        tiles.forEach((tile, index) => {
          const depth = 6 + (index % 3) * 4;
          tile.style.setProperty('--holy-tilt-x', `${x * depth}px`);
          tile.style.setProperty('--holy-tilt-y', `${y * depth}px`);
        });
      });

      mosaic.addEventListener('mouseleave', () => {
        tiles.forEach((tile) => {
          tile.style.setProperty('--holy-tilt-x', '0px');
          tile.style.setProperty('--holy-tilt-y', '0px');
        });
      });
    } else {
      tiles.forEach((tile) => tile.classList.add('is-visible'));
    }
  });
})();
